<template>
	<section class="content">
		<div class="row">
			<div class="col-md-12">
				<div class="box box-primary">
					<div class="box-header with-border">

						<h3 class="box-title">
							<b>Novo Procedimento do Contrato</b>
						</h3>
					</div>

					<div class="box-body">
						<cabecario-contrato :contratoId="$route.params.contrato_id ? $route.params.contrato_id : dados.contrato.id"></cabecario-contrato>
						<div class="row">
							<div class="col-md-6">
								<div class="form-group">
									<label :class="{'erro-validacao': showTextDangerProcedimento}">Procedimento</label>
									<select-procedimento :show-text-danger-procedimento="showTextDangerProcedimento" @setProcedimentoSelecionado="(procedimentoSelecionado)=>{setProcedimentoSelecionado(procedimentoSelecionado)}" :nomeProcedimento="dados.procedimento.nome"></select-procedimento>
								</div>
							</div>
							<div class="col-md-6">
								<div class="form-group">
									<label :class="{'erro-validacao': showTextDangerPreparo}">Preparo</label>
									<select-preparo :show-text-danger-preparo="showTextDangerPreparo" @setPreparoSelecionado="(preparoSelecionado)=>{setPreparoSelecionado(preparoSelecionado)}" :nomePreparo="dados.preparo.nome"></select-preparo>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-3" :class="{'has-error': showTextDangerValor}">
								<div class="form-group">
									<label :class="{'erro-validacao': showTextDangerValor}">Valor (R$)</label>
									<money class="form-control" v-model="dados.valor" v-bind="money" ref="valor" autofocus></money>
								</div>
							</div>

							<div class="col-md-3" :class="{'has-error': showTextDangerTipoLimite}">
								<div class="form-group">
									<label :class="{'erro-validacao': showTextDangerTipoLimite}">Tipo de Limite</label>
									<select placeholder="Selecione" v-model="dados.tipo_limite" class="form-control">
										<option value="0" v-if="procedimentoSelecionado.tipo_atendimento == 0">Procedimento</option>
										<option value="1">Subgrupo</option>
										<option value="2" v-if="procedimentoSelecionado.tipo_atendimento == 0">Geral</option>
									</select>
								</div>
							</div>

							<div class="col-md-3" :class="{'has-error': showTextDangerLimite}">
								<div class="form-group">
									<label :class="{'erro-validacao': showTextDangerLimite}">Limite Físico</label>
									<input :disabled="dados.tipo_limite == 0?false:true" v-model="dados.limite.quantidade" class="form-control" type="number" ref="limite_fisico">
								</div>
							</div>

							<div class="col-md-3">
								<div class="form-group">
									<label>Valor Total (R$)</label>
									<input :disabled="true" :value="controle.limite_financeiro | numberFormat(2,',','.')" class="form-control" type="text">
								</div>
							</div>

						</div>

					</div>
					<div class="box-footer">
						<div class="row">
							<div class="col-md-12">
								<button @click="salvar()" class="btn btn-primary pull-right" type="button"><i class="fa fa-save"></i> Salvar</button>
								<button class="btn btn-default pull-left" @click="$router.go(-1)"><i class="fa fa-close"></i> Cancelar</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</section>
</template>

<script>
	import axios from "axios"; // Cliente para requisição http
	import selectProcedimento from "../../cadastros/procedimentos/selectProcedimento";
	import selectPreparo from "../../cadastros/preparos/selectPreparo";
	import CabecarioContrato from './cabecarioContrato';

	import {
		Money
	} from 'v-money';

	export default {
		props: ['contratoId'],
		filters: {},
		data: () => ({
			atualizacao: false,
			showTextDangerValor: false,
			showTextDangerProcedimento: false,
			showTextDangerPreparo: false,
			showTextDangerTipoLimite: false,
			showTextDangerLimite: false,

			procedimentoSelecionado: {},
			preparoSelecionado: {},
			money: {
				decimal: ',',
				thousands: '.',
				prefix: 'R$ ',
				precision: 2,
				masked: false
			},
			dados: {
				valor: 0,
				tipo_limite: null,
				procedimento_id: null,
				preparo_id: null,
				contrato_id: null,
				procedimento: {
					nome: null
				},
				preparo: {
					nome: null
				},
				limite: {
					quantidade: null
				},
				contrato: {
					id: null,
				}
			},

			controle: {
				limite_financeiro: null,
			}

		}),
		mounted() {
			if (this.$route.params.contrato_procedimento_id) {
				this.$nextTick(() => {
					this.getById(this.$route.params.contrato_procedimento_id);
				this.atualizacao = true;
				})
			} else {
				this.dados.contrato_id = this.$route.params.contrato_id;
			}
		},
		methods: {
			salvar() {
				if (this.validar()) {
					if (this.atualizacao) {
						axios.post(
								`${this.$store.state.serverURI}/api/administracao/contratos/updateContratoProcedimento/${this.dados.id}`,
								this.dados,
								this.$store.getters.getHeaderAuth
							)
							.then(response => {
								this.$swal({
									type: "success",
									title: "Procedimento atualizado com sucesso!",
									showConfirmButton: false,
									timer: 1500
								});
								this.$router.push(`/administracao/contratos/procedimentos/${this.dados.contrato_id}`);
							})
							.catch(error => {
								var erros = error.response.data.message + " ";
								for (var erro of Object.values(error.response.data.errors)) {
									erros += erro + " \n";
								}
								this.$swal({
									type: "error",
									title: "Houve uma falha!",
									text: erros
								});
							});
					} else {
						axios.post(
								`${this.$store.state.serverURI}/api/administracao/contratos/createContratoProcedimento`,
								this.dados,
								this.$store.getters.getHeaderAuth
							)
							.then(response => {
								if (response.data.status) {
									this.$swal({
										type: "success",
										title: response.data.msg,
										showConfirmButton: false,
										timer: 1500
									});
									this.$router.push(`/administracao/contratos/procedimentos/${this.dados.contrato_id}`);
								} else {
									this.$swal({
										type: "error",
										title: response.data.titulo_msg,
										text: response.data.msg,
										showConfirmButton: true,
									}).then(() => {
										this.$router.push(`/administracao/contratos/procedimentos/${this.dados.contrato_id}`);
									});
								}

							})
							.catch(error => {
								var erros = error.response.data.message + " ";
								for (var erro of Object.values(error.response.data.errors)) {
									erros += erro + " \n";
								}
								this.$swal({
									type: "error",
									title: "Houve uma falha!",
									text: erros
								});
							});
					}
				} else {
					this.$swal({
						type: "error",
						title: "Informações pendentes",
						text: "Preencha corretamente os campos destacados em vermelho!",
					});
				}
			},

			getById(contratoProcedimentoId) {
				this.$store.commit('TOGGLE_LOADING');
				axios.get(`${this.$store.state.serverURI}/api/administracao/contratos/getContratoProcedimentoById/${contratoProcedimentoId}`, this.$store.getters.getHeaderAuth).then(response => {
				if (!response.data.limite) {
						response.data.limite = {
							quantidade: null
						};
					}
					if (!response.data.preparo) {
						response.data.preparo = {
							nome: ''
						};
					}
					this.dados = response.data;
					this.procedimentoSelecionado = this.dados.procedimento;
					this.preparoSelecionado = this.dados.preparo;
					this.$store.commit('TOGGLE_LOADING');
				}).catch((error) => {
					console.log(error)
				});
			},

			setProcedimentoSelecionado(procedimentoSelecionado) {
				this.procedimentoSelecionado = procedimentoSelecionado;
				this.dados.procedimento_id = procedimentoSelecionado.id;
				this.dados.valor = procedimentoSelecionado.valor_referencia;

				if (procedimentoSelecionado.tipo_atendimento == 0) {
					/* se o procedimento for do tipo individual */
					this.dados.tipo_limite = 0;
				} else if (procedimentoSelecionado.tipo_atendimento == 1) {
					/* se o procedimento for do tipo agrupado */
					this.dados.tipo_limite = 1;
				}
			},
			setPreparoSelecionado(preparoSelecionado) {
				this.preparoSelecionado = preparoSelecionado;
				this.dados.preparo_id = preparoSelecionado.id;
			},
			validar() {
				let validou = true;
				if (this.dados.valor === '') {
					this.showTextDangerValor = true;
					validou = false;
				}
				if (this.dados.tipo_limite === null) {
					this.showTextDangerTipoLimite = true;
					validou = false;
				}
				if (this.dados.procedimento_id === null) {
					this.showTextDangerProcedimento = true;
					validou = false;
				}
				/*
				if (this.dados.preparo_id === null) {
					this.showTextDangerPreparo = true;
					validou = false;
				}
				*/
				if (this.dados.tipo_limite === 0 && this.dados.limite.quantidade === null) {
					this.showTextDangerLimite = true;
					validou = false;
				}
				return validou;
			},
		},
		watch: {

			"dados.valor": function(newValue) {
				if (this.dados.valor > 0 && this.dados.limite.quantidade > 0) {
					this.controle.limite_financeiro = (this.dados.valor * this.dados.limite.quantidade);
				}
			},

			"dados.limite.quantidade": function(newValue) {
				if (this.dados.valor && this.dados.limite.quantidade) {
					this.controle.limite_financeiro = (this.dados.valor * this.dados.limite.quantidade);
				}
			},

			"dados.tipo_limite": function(newValue) {
				if (newValue > 0) {
					/* se o tipo limite for subgrupo ou geral */
					this.dados.limite.quantidade = null;
					this.controle.limite_financeiro = null;

				}
				this.$nextTick(() => {
					this.$refs.limite_fisico.focus();
				});
			}

		},
		components: {
			selectProcedimento,
			Money,
			selectPreparo,
			CabecarioContrato
		}
	};
</script>

<style>

</style>



// WEBPACK FOOTER //
// contratoProcedimentoForm.vue?53d758f1